import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const ArticleProof = () => {
  return (
    <Container>
      <h2 className="display-6 fw-bold my-4">Article Proofs</h2>
      <hr />

      <p className="joab-common-para my-2 ">
        Authors subsequently receive an e-proof, including the figures, and can
        also download a PDF proof of the layout. We suggest that authors send
        proofs to co-authors for them to check, but request that changes among
        the co-authors are coordinated so that only one author communicates and
        only one set of corrections is sent. The corresponding (or other single
        designated) author is responsible on behalf of all co-authors for the
        accuracy of all content, including spelling of names and current
        affiliations of all co-authors, so please ensure these are checked
        carefully.
      </p>
    </Container>
  );
};

export default ArticleProof;
